.section {
  margin-bottom: 16px;
}

.roleSelect {
  width: 150px;
}

.statusSelect {
  width: 120px;
}

.searchInput {
  width: 250px;
}

.linkCell {
  padding: 0;
}
